import React, { useState, useEffect } from 'react';
import './found-collaborator-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

const FoundCollaboratorModal = ({
  show,
  cancel,
  collabProfile,
  confirm,
  loading,
  regsData,
  setAlertMessage
}) => {

  const [ role, setRole ] = useState(null);

  useEffect(() => {
    if (!role || !regsData) return;
    if (role === 'manager' && collabProfile?.membership < 2) {
      setAlertMessage('This role requires the user you are inviting to have a higher membership level. Please send them to https://app.gamably.com/plan to upgrade.');
      setRole(null);
      return;
    }
    if (role === 'distributor') {
      const existingDistributors = Object.values(regsData.roles)?.filter(reg => reg.includes('distributor')).length ?? 0;
      if (existingDistributors >= 2) {
        setAlertMessage('You have already reached the maximum number of distributors for this game. You cannot have more than two without being part of an Enterprise plan.');
        setRole(null);
        return;
      }
    }
  }, [role, regsData])

  return (
    <div className="found-collaborator-modal">
      <Modal
        show={show}
        cancel={cancel}
        text="Potential Collaborator Found!"
        closeButton={true} >
        <div className="modal-content">
          <p>
            A user with the email <b>{collabProfile?.email}</b> has been found. 
            Would you like to invite them as a collaborator?
          </p>
          {/* <div className="g-space-1"></div> */}
          {/* {
            (collabProfile && collabProfile.appId) &&
            <div className='found-user'>
              <UserIcon profile={collabProfile ? collabProfile : {}} />
              {collabProfile.fName} {collabProfile.lName} 
            </div>
          } */}
          <div className='g-space-1'></div>
          <div className='field small'>
            <label>Choose a Role for this collaborator</label>
            <select 
              id='collab-role-select'
              value={role ?? ''}
              onChange={(e) => setRole(e.target.value)}>
              <option value="">Choose a role...</option>
              <option value="distributor">Distributor</option>
              <option value="manager">Game Manager{collabProfile?.membership < 2 ? ' (Requires higher membership)' : ''}</option>
            </select>
          </div>
          <div className="g-space-2"></div>
          {
            loading
            ?
            <div className='buttons'>
              <button className='g-button'>Cancel</button>
              <button className='g-button' disabled>
                <ThreeDotsLoader />
              </button>
            </div>
            :
            <div className="buttons">
              <button 
                className="g-button" 
                onClick={cancel}>
                Cancel
              </button>
              <button 
                className={`g-button ${collabProfile && role ? 'primary' : 'disabled'}`} 
                onClick={() => confirm(role)}>
                Invite Collaborator
              </button>
            </div>
          }
        </div>    
      </Modal>
    </div>
  )
}

export default FoundCollaboratorModal